import React from 'react';
import { Helmet } from 'react-helmet';
import { Container, Row, Col, Card, ListGroup } from 'react-bootstrap';
import './ZH.css';
import img1 from '../Components/Images/TIJ/tijh1.png';
import img2 from '../Components/Images/TIJ/ZAR-TIJ1.png';
import img3 from '../Components/Images/applications/tij1.png';
import img4 from '../Components/Images/applications/tij2.png';
import img5 from '../Components/Images/applications/tij3.png';
import img6 from '../Components/Images/applications/tij4.png';
import img7 from '../Components/Images/applications/tij5.png';
import img8 from '../Components/Images/applications/tij6.png';
import img9 from '../Components/Images/TIJ/box.png';
import img10 from '../Components/Images/TIJ/controller.png';
import img11 from '../Components/Images/TIJ/battery.png';
import img12 from '../Components/Images/TIJ/adapter.png';
import img13 from '../Components/Images/TIJ/toolkit.png';

function ZH() {
  const images = [
    { id: 1, src: img3, alt: 'Handheld TIJ printer marking on cables' },
    { id: 2, src: img4, alt: 'Portable inkjet printer coding on metal surfaces' },
    { id: 3, src: img5, alt: 'Rechargeable inkjet printer marking pipes' },
    { id: 4, src: img6, alt: 'Quick dry inkjet hand printer on plastic materials' },
    { id: 5, src: img7, alt: 'Lightweight mobile coding printer for carton labeling' },
    { id: 6, src: img8, alt: 'Battery operated inkjet printer on wood surfaces' },
  ];

  const items = [
    { id: 1, quantity: '2', name: 'Controller' },
    { id: 2, quantity: '4', name: 'Power adapter' },
    { id: 3, quantity: '1', name: 'Metal box' },
    { id: 4, quantity: '3', name: 'Battery' },
    { id: 5, quantity: '5', name: 'Tool kit' }
  ];

  const products = [
    {
      id: 1,
      name: 'Metal box',
      image: img9,
      number: 1,
      isLarge: true
    },
    {
      id: 2,
      name: 'Controller',
      image: img10,
      number: 2
    },
    {
      id: 3,
      name: 'Battery',
      image: img11,
      number: 3
    },
    {
      id: 4,
      name: 'Power adapter',
      image: img12,
      number: 4
    },
    {
      id: 5,
      name: 'Tool kit',
      image: img13,
      number: 5
    }
  ];

  return (
    <div>
      <Helmet>
        <title>Handheld TIJ Printer | Portable Inkjet Coding Machine | Rechargeable Marking System</title>
        <meta name="description" content="Premium handheld TIJ printer for portable marking on various surfaces. Features quick-dry ink, rechargeable battery, and industrial-grade durability. Ideal for carton labeling, metal coding, and more." />
        <meta name="keywords" content="handheld TIJ printer, rechargeable inkjet printer, portable inkjet printers, quick dry inkjet hand printer, lightweight mobile coding printer, battery operated inkjet printer, carton and box labeling, portable inkjet printer China supplier, export quality hand jet printer" />
        <meta property="og:title" content="Industrial Handheld TIJ Printer - Portable Marking Solution" />
        <meta property="og:description" content="High-quality portable inkjet printer for industrial coding and marking applications" />
        <link rel="canonical" href="https://www.zartecsolutions.com/handheld-tij-printer" />
      </Helmet>

      <section className="handheld-printers">
        <Container>
          <Row className="">
            <Col className="text-center">
              <h1 className="section-title1">
                INDUSTRIAL HANDHELD TIJ PRINTERS
              </h1>
              <p className="section-subtitle1">
                Portable inkjet coding solutions for industrial marking on metal, plastic, cartons, and more
              </p>
            </Col>
          </Row>

          <Row className="g-0 justify-content-center align-items-center">
            <Col xs={12} md={10} lg={6} className="text-center">
              <img 
                src={img1}
                className="img-fluid"
                style={{
                  width: "auto",
                  objectFit: "contain",
                  marginTop: "0px",
                  padding: "0px"
                }}
                alt="Handheld TIJ printer with ergonomic design for industrial marking applications"
                loading="lazy"
              />
            </Col>
          </Row>
        </Container>
      </section>

      <section className="product-specs py-1">
        <Container>
          <h2 className="section-title1 fonthead mb-4">Handheld Printer Specifications</h2>
          
          <Card className="specs-card shadow-sm">
            <Card.Body>
              <Row>
                <Col md={4}>
                  <div className="feature-list">
                    <h3 className="specs-subtitle">Key Features of Our Portable Inkjet Printer</h3>
                    <ul className="list-unstyled">
                      <li className="feature-item">
                        <span className="feature-number">1.</span>
                        <span className="feature-text">4.3 inch touch screen for easy operation</span>
                      </li>
                      <li className="feature-item">
                        <span className="feature-number">2.</span>
                        <span className="feature-text">Industrial grade high-quality materials for durability</span>
                      </li>
                      <li className="feature-item">
                        <span className="feature-number">3.</span>
                        <span className="feature-text">Support customized services for specific marking needs</span>
                      </li>
                      <li className="feature-item">
                        <span className="feature-number">4.</span>
                        <span className="feature-text">2,600mAh removable battery for extended use</span>
                      </li>
                    </ul>
                  </div>
                </Col>

                <Col md={8}>
                  <div className="technical-details">
                    <h3 className="specs-subtitle">Handheld Printer Applications</h3>
                    <Container className="py-2">
                      <Row className="g-4">
                        {images.map((image) => (
                          <Col key={image.id} xs={12} sm={6} md={4}>
                            <div className="image-card">
                              <img 
                                src={image.src} 
                                alt={image.alt}
                                className="img-fluid rounded"
                                style={{maxHeight: "150px"}}
                                loading="lazy"
                              />
                              <div className="image-overlay">
                                <p className="image-caption">{image.alt}</p>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    </Container>
                  </div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Container>
      </section>

      <section className="parameters-section py-1">
        <Container>
          <h2 className="section-title1 text-center fonthead mb-3 mt-5">Technical Specifications of Handheld TIJ Printer</h2>
          
          <Card className="specs-card shadow-lg">
            <Card.Body>
              <div className="table-responsive">
                <table className="table table-borderless specs-table">
                  <tbody>
                    <TableRow 
                      parameter="Printing Technology" 
                      value="HP TIJ2.5 Thermal Inkjet Technology for precise marking" 
                    />
                    <TableRow 
                      parameter="Operation System" 
                      value="Linux-based stable operating system" 
                    />
                    <TableRow 
                      parameter="Processor" 
                      value="Industrial grade CPU for reliable performance" 
                    />
                    <TableRow 
                      parameter="Connectivity" 
                      value="USB interface for easy data transfer" 
                    />
                    <TableRow 
                      parameter="Supported Languages" 
                      value="Arabic, Chinese, English, French, German, Greek, Italian, Korean, Persian, Portuguese, Russian, Spanish, Thai, Turkish, etc (support customization)"
                    />
                    <TableRow 
                      parameter="Optimal Print Distance" 
                      value="2-5mm for clear, consistent marks" 
                    />
                    <TableRow 
                      parameter="Print Resolution" 
                      value="300dpi Maximum for high-quality coding" 
                    />
                    <TableRow 
                      parameter="Adjustable Print Height" 
                      value="1-12.7mm for versatile applications" 
                    />
                    <TableRow 
                      parameter="Print Content Options" 
                      value="Text, Numbers, QR Codes, Barcodes, Images, Dates, etc" 
                    />
                    <TableRow 
                      parameter="Compatible Materials" 
                      value="Board, Carton, Stone, Pipe, Cable, Metal, Plastic, Glass, Paper and more" 
                    />
                    <TableRow 
                      parameter="Battery Capacity" 
                      value="2,000mAh @ DC16.8V for extended portable use" 
                    />
                    <TableRow 
                      parameter="Power Supply" 
                      value="Input: 100-240V AC; Output: 168V/2A DC universal adapter" 
                    />
                    <TableRow 
                      parameter="Construction Material" 
                      value="Durable ABS+PC composite housing" 
                    />
                    <TableRow 
                      parameter="Product Weight" 
                      value="Only 0.82KG - lightweight and portable" 
                    />
                  </tbody>
                </table>
              </div>
            </Card.Body>
          </Card>
        </Container>
      </section>
    </div>
  )
}

const TableRow = ({ parameter, value, icon, isHighlighted = false }) => {
  return (
    <tr className={isHighlighted ? "highlighted-row" : ""}>
      <td className="parameter-cell">
        {icon && <span className="parameter-icon">{icon}</span>}
        <strong>{parameter}</strong>
      </td>
      <td className="value-cell">{value}</td>
    </tr>
  );
};

export default ZH;